export function OnWeekIcon({
  width = 24,
  height = 24,
  className = '',
}: {
  width?: number;
  height?: number;
  className?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_315_34584)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.42857 3.42815C2.4818 3.42815 1.71429 4.19566 1.71429 5.14244V20.571C1.71429 21.5178 2.4818 22.2853 3.42857 22.2853H20.5714C21.5182 22.2853 22.2857 21.5178 22.2857 20.571V5.14244C22.2857 4.19566 21.5182 3.42815 20.5714 3.42815H3.42857ZM0 5.14244C0 3.24889 1.53502 1.71387 3.42857 1.71387H20.5714C22.465 1.71387 24 3.24889 24 5.14244V20.571C24 22.4646 22.465 23.9996 20.5714 23.9996H3.42857C1.53502 23.9996 0 22.4646 0 20.571V5.14244Z"
          fill="#FFFA6D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.1423 0C5.61569 0 5.99944 0.383756 5.99944 0.857143V2.57143C5.99944 3.04482 5.61569 3.42857 5.1423 3.42857C4.66891 3.42857 4.28516 3.04482 4.28516 2.57143V0.857143C4.28516 0.383756 4.66891 0 5.1423 0Z"
          fill="#FFFA6D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8571 0C19.3305 0 19.7143 0.383756 19.7143 0.857143V2.57143C19.7143 3.04482 19.3305 3.42857 18.8571 3.42857C18.3838 3.42857 18 3.04482 18 2.57143V0.857143C18 0.383756 18.3838 0 18.8571 0Z"
          fill="#FFFA6D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6.85714C0 6.38376 0.383756 6 0.857143 6H23.1429C23.6162 6 24 6.38376 24 6.85714C24 7.33053 23.6162 7.71429 23.1429 7.71429H0.857143C0.383756 7.71429 0 7.33053 0 6.85714Z"
          fill="#FFFA6D"
        />
        <path
          d="M9.00532 10.5459H15.465C15.565 10.5459 15.6441 10.5792 15.7024 10.6459C15.769 10.7125 15.8024 10.7916 15.8024 10.8833V12.5325C15.8024 12.7241 15.7482 12.9365 15.6399 13.1698L12.9161 19.0047C12.8078 19.1963 12.6371 19.2921 12.4038 19.2921H9.99239C9.91743 19.2921 9.85079 19.2671 9.79248 19.2171C9.7425 19.1588 9.71751 19.1005 9.71751 19.0422C9.71751 18.9839 9.72584 18.9381 9.7425 18.9048L12.4413 13.1073H9.00532C8.9137 13.1073 8.83456 13.074 8.76793 13.0073C8.70129 12.9407 8.66797 12.8616 8.66797 12.7699V10.8833C8.66797 10.7916 8.70129 10.7125 8.76793 10.6459C8.83456 10.5792 8.9137 10.5459 9.00532 10.5459Z"
          fill="#FFFA6D"
        />
      </g>
      <defs>
        <clipPath id="clip0_315_34584">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default OnWeekIcon;
